import { render, staticRenderFns } from "./FAQInvitation.vue?vue&type=template&id=3b2f7d5d&scoped=true"
import script from "./FAQInvitation.vue?vue&type=script&lang=js"
export * from "./FAQInvitation.vue?vue&type=script&lang=js"
import style0 from "./FAQInvitation.vue?vue&type=style&index=0&id=3b2f7d5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f7d5d",
  null
  
)

export default component.exports